import { Moon, Sun } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useTheme } from "@/context/theme/theme-context.ts"
import { useAuth } from "@/context/auth/auth-context"
import hive from "@/lib/api/hive"
import { Analytics } from "@/lib/analytics"

export function ThemeToggle() {
	const { theme, setTheme } = useTheme()
	const { token, isAuthenticated } = useAuth()

	const toggle = () => {
		const effective =
			theme === "system" ? (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light") : theme
		const next = effective === "dark" ? "light" : "dark"
		setTheme(next)
		Analytics.capture("Theme Changed", { theme: next })
		if (isAuthenticated && token) {
			hive.updateMe({ email_theme: next }, token).catch(() => {})
		}
	}

	return (
		<Button variant="ghost" size="icon" className="rounded-full" onClick={toggle}>
			<Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0 text-sky-500" />
			<Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100 text-sky-300" />
			<span className="sr-only">Toggle theme</span>
		</Button>
	)
}
